import React from "react";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { TopBarItem, NumberBadge } from "components/TopBar";
import Icon from "components/CommonIcon/Icon";
import useDrawer from "hooks/useDrawer";
import { LanguageSelectorDrawer } from "components/LanguageSelector";

import MenuToolTipBody from "components/Design/MenuToolTipBody/MenuTooltipBody";
import { MenuToolTipBodyItem } from "components/Design/MenuToolTipBody/MenuTooltipBody";
import {
  AYANA_REWARD_LINK,
  AYANA_JAKARTA_MY_RESERVATION_LINK,
} from "store/constants/link";
import { embedLanguageInUrl } from "utils/embedLanguageInUrl";
import Divider from "components/Design/Divider/Divider";
import ConditionalLink from "components/ConditionalLink";
import { AYANA_JAKARTA_ID } from "store/constants/hotel";
import Tooltip from "components/Design/Tooltip/Tooltip";

const NavIconWrapper = () => (
  <div className="bg-blue-ayana p-8 inline-block">
    <Icon name="close" color="text-white" fontSize="text-16" />
  </div>
);

const languageName = {
  en: "ENG",
  id: "INA",
  zh: "CHI",
  ja: "JPN",
  ko: "KOR",
};

function NavOpenHeader({ onClose, bookingEngineLink, cartCount, hotel }) {
  const { language } = useI18next();
  const { t } = useTranslation("homepage");
  const { isOpen, open, close } = useDrawer();

  const myReservationLink =
    hotel.id === AYANA_JAKARTA_ID
      ? AYANA_JAKARTA_MY_RESERVATION_LINK
      : `${embedLanguageInUrl(process.env.GATSBY_BOOKING_ENGINE_URL, language, [
          "",
        ])}/find-reservation/`;

  return (
    <div className="sticky top-0 w-full z-100 bg-white">
      <div className="shadow-nav-header py-12 px-20 flex justify-between">
        <div className="text-10-10 font-mulish flex space-x-24 font-semibold">
          <TopBarItem
            suffixIcon={
              <Icon
                name="chevron-down"
                color="text-gray-text"
                fontSize="text-12"
              />
            }
            onClick={open}>
            {t(languageName[language])}
          </TopBarItem>
        </div>
        <div className="flex items-center space-x-30">
          {cartCount > 0 && (
            <ConditionalLink link={bookingEngineLink || ""} sameTab>
              <TopBarItem suffixIcon={<NumberBadge number={cartCount} />}>
                <span className="cursor-pointer">
                  <Icon name="cart" />
                </span>
              </TopBarItem>
            </ConditionalLink>
          )}
          <Tooltip
            trigger={
              <span className="cursor-pointer">
                <Icon name="profile" />
              </span>
            }
            openOnHover>
            <div className="text-black capitalize z-100">
              <MenuToolTipBody>
                <div>
                  <h3 className="font-bold">{t("Account")}</h3>
                </div>
                <Divider />
                <MenuToolTipBodyItem
                  to={`${embedLanguageInUrl(AYANA_REWARD_LINK, language, [
                    "ko",
                  ])}/login`}>
                  {t("Login to AYANA Rewards")}
                </MenuToolTipBodyItem>
                <MenuToolTipBodyItem
                  to={`${embedLanguageInUrl(AYANA_REWARD_LINK, language, [
                    "ko",
                  ])}/signup`}>
                  {t("Join AYANA Rewards")}
                </MenuToolTipBodyItem>
                <MenuToolTipBodyItem to={myReservationLink}>
                  {t("My Reservation")}
                </MenuToolTipBodyItem>
              </MenuToolTipBody>
            </div>
          </Tooltip>
          <div onClick={onClose} className="cursor-pointer">
            <NavIconWrapper />
          </div>
        </div>
      </div>
      <LanguageSelectorDrawer visible={isOpen} onClose={close} />
    </div>
  );
}

export default NavOpenHeader;
